<template>
  <div>
    <header class="headet-title">
      <div class="headet-title-box">转账</div>
    </header>
    <div style="padding:0px 30px 20px 30px">
      <el-tabs v-model="activeName" type="border-card">
        <el-tab-pane label="转账到Dopay钱包" name="transferToAccount">
          <div class="transfer-body" style="marginTop:40px">
            <el-form ref="transferToAccountForm" :model="transferToAccountForm" :rules="rules" label-width="150px">
              <el-form-item label="收款人：" prop="accountName">
                <el-autocomplete
                  v-model="transferToAccountForm.accountName"
                  :fetch-suggestions="querySearch"
                  placeholder="请输入收款人账号或手机号"
                  :trigger-on-focus="false"
                  @select="handleSelect"
                />
              </el-form-item>
              <el-form-item label="收款人名称：">
                <el-input v-model="contactName" style="width:200px;" disabled />
              </el-form-item>
              <el-form-item label="转账金额：" prop="transferAmount">
                <el-input
                  v-model="transferToAccountForm.transferAmount"
                  style="width:200px;"
                  placeholder="0.00"
                  type="number"
                  clearable
                />
                元
              </el-form-item>
              <el-form-item label="转账说明：">
                <el-input
                  v-model="transferToAccountForm.remark"
                  type="textarea"
                  :rows="3"
                  placeholder="请输入内容"
                  maxlength="30"
                  show-word-limit
                  style="width:300px;"
                />
              </el-form-item>
              <el-form-item label="支付密码：">
                <span id="tradePassword" />
          
              </el-form-item>
              <el-form-item class="pb-50">
                <el-button type="primary" :loading="loadingOpenDialogBut" @click="openDialog('transferToAccountForm')">{{ loadingOpenDialogButtext }}</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane label="转账到银行卡" name="transferToCard">
          <div class="transfer-body" style="marginTop:40px">
            <el-form ref="transToBankForm" :model="transToBankForm" label-width="150px" :rules="bankRules">
              <el-form-item label="可用余额：" prop="">
                <div>{{ balance }}元</div>
              </el-form-item>
              <el-form-item label="账户名：" prop="recUserName">
                <el-row>
                  <el-input :disabled="bankItem.historyFlag && transToBankForm.recUserName ? true: false" v-model="transToBankForm.recUserName" placeholder="开户人姓名" style="width:211px;" />
                </el-row>
              </el-form-item>
              <el-form-item label="银行账号" prop="recCardNo">
                <el-row>
                  <el-input :disabled="bankItem.historyFlag" v-model="transToBankForm.recCardNo" @blur="getBankByNameResp()" placeholder="储蓄卡号" style="width:211px;" />
                  <el-popover
                    placement="bottom-start"
                    title="我的历史记录"
                    width=""
                    trigger="click">
                    <div :style="{overflowY : payRecordList.length > 6 ? 'scroll' : ''}" style="max-height: 300px;">
                      <div style="margin-bottom: 10px" v-for="(item, i) in payRecordList" :key="i" @click="getPayRecord(item)">
                        <div style="font-size: 18px;">{{ item.accNameMask }}</div>
                        <div>{{ item.accountBank }}{{ `(${item.accNoMask})`}}</div>
                      </div>
                    </div>
                    <el-button style="margin-left:20px" type="text" slot="reference">付款记录<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                  </el-popover>
                </el-row>
              </el-form-item>
              <el-form-item label="收款银行：" prop="bankCode">
                <el-row>
                  <el-select
                    v-model="bankItem.codeAndName"
                    placeholder="选择/输入银行"
                    style="width:211px;"
                    filterable
                    :disabled="bankItem.disBankFlag"
                    value-key="codeAndName"
                    @change="getBankBean"
                  >
                    <el-option
                      v-for="item in bankList"
                      :key="item.id"
                      :label="item.bankName"
                      :value="item.codeAndName"
                    />
                  </el-select>
                </el-row>
              </el-form-item>
              <el-form-item label=" 收款账户类型" prop="accountType">
                <el-radio-group :disabled="bankItem.cardTypeFlag" v-model="transToBankForm.accountType">
                  <el-radio v-for="item in accountTypeList" :key="item.key" :label="item.key">{{ item.accountName }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="联行号" prop="bankNumber" :rules="[{ required: transToBankForm.accountType == '00' ? true : false,trigger: 'blur',message: '请输入联行号' }]">
                <el-input
                  v-model="transToBankForm.bankNumber"
                  :disabled="transToBankForm.accountType == '00' ? false : true"
                  style="width:200px;"
                  type="number"
                  clearable/>
              </el-form-item>
              <el-form-item label="转账金额：" prop="recBankTransferAmt">
                <el-input
                  v-model="transToBankForm.recBankTransferAmt"
                  style="width:200px;"
                  type="number"
                  clearable
                  @blur="getBankFee"
                />
                元
                <el-row><span style="color: silver">{{ this.bankFeeMsg }}</span></el-row>
              </el-form-item>
              <el-form-item label="服务费：">
                <div class="sub-title">
                  {{ this.transToBankForm.transferFee }}元
                </div>
              </el-form-item>
              <el-form-item label="账户扣除金额：">
                <div class="sub-title">
                  <span style="color: red">{{ totAmount }}</span>元
                </div>
              </el-form-item>
              <el-form-item label="备注：">
                <el-input
                  v-model="transToBankForm.remark"
                  type="textarea"
                  :rows="3"
                  placeholder="请输入内容"
                  maxlength="30"
                  show-word-limit
                  style="width:301px;"
                />
              </el-form-item>
              <el-form-item label="支付密码:">
                <span id="paymentPassword" />
              
              </el-form-item>
              <el-form-item class="pb-50">
                <el-button type="primary" style="width:147px" :loading="loadingBankSubmitBut" @click="bankFormSubmit('transToBankForm')">{{ loadingBankSubmitButtext }}</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane label="自动转账" name="autoTransfer">
          <div class="transfer-body" style="margin-top:40px">
            <el-form ref="transToAutoForm" :model="transToAutoForm" label-width="150px" :rules="autoRules">
              <el-form-item label="客户名称：" prop="recUserName">
                <div class="sub-title">收款账户
                  {{ transToAutoForm.customerName }}
                </div>
              </el-form-item>
              <el-form-item label="客户编号：" prop="recUserName">
                <div class="sub-title">
                  {{ transToAutoForm.customerNo }}
                </div>
              </el-form-item>
              <el-form-item label="收款账户：" prop="account">
                <el-select
                  v-model="transToAutoForm.account"
                  style="width: 420px;"
                  placeholder="请选择"
                  :disabled="!(updateFlag==true || autoPayId==null)"
                  @change="changeAccount"
                >
           
                  <el-option v-for="item in accountList" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
              <el-form-item label="账户存留金额：" prop="keepBalance">
                <el-input
                  v-model="transToAutoForm.keepBalance"
                  style="width:200px;"
                  :disabled="!(updateFlag==true || autoPayId==null)"
                />
                元
                <el-row><span style="color: silver">服务费：{{ this.autoFeeMsg }}</span></el-row>
              </el-form-item>
              <el-form-item label="自动转账时间：">
                <el-checkbox-group :disabled="!(updateFlag==true || autoPayId==null)" v-model="transToAutoForm.paymentTime">
                  <el-checkbox label="10:00:00">每天10:00:00开始</el-checkbox>
                  <el-checkbox label="16:00:00">每天16:00:00开始</el-checkbox>
                </el-checkbox-group>
                <div class="sub-title" style="color: red">
                  发起自动转账后预计资金两小时内到账，<br>
                  若自动转账开通时间在此时间之后，则将转账时间顺延到次日，当日不进行转账
                </div>
              </el-form-item>
              <el-form-item label="转账说明：">
                <el-input
                  v-model="transToAutoForm.remark"
                  type="textarea"
                  :rows="3"
                  placeholder="请输入内容"
                  maxlength="30"
                  show-word-limit
                  style="width:301px;"
                  :disabled="!(updateFlag==true || autoPayId==null)"
                />
              </el-form-item>
              <el-form-item label="支付密码:">
                <span id="autoPassword" />
              </el-form-item>
              <el-form-item class="pb-50">
                <div v-if="autoPayId==null">
                  <el-button type="primary" style="width:147px" :loading="autoOpenButloading" :disabled="autoOpenButloading" @click="autoFormSubmit()">{{ autoOpenButText }}</el-button>
                </div>
                <div v-else>
                  <div v-if="updateFlag==true">
                    <el-button type="info" style="width:147px" :loading="autoCancelButloading" :disabled="autoCancelButloading" @click="cancelUpdate()">{{ autoCancelButText }}</el-button>
                    <el-button type="primary" style="width:147px" @click="autoFormUpdateSubmit('02')">确定</el-button>
                  </div>
                  <div v-else>
                    <el-button type="success" style="width:147px" @click="autoUpdate()">修改</el-button>
                    <el-button type="primary" style="width:147px" @click="autoFormUpdateSubmit('01')">关闭自动转账</el-button>
                  </div>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog title="转账确认" :visible.sync="dialogFormVisible" :before-close="handleClose" :close-on-click-modal="false" width="400px" center>
      <span style="color: red">您确定要向账号为{{ this.transferToAccountForm.accountName }}的账号中转入{{ this.transferToAccountForm.transferAmount }}元</span>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="loadingSubmitBut" @click="formSubmit('transferToAccountForm')">{{ loadingSubmitButtext }}</el-button>
        <el-button @click="handleClose">取消</el-button>
      </div>
    </el-dialog>
    <input id="lic" type="hidden">
  </div>
</template>
<script>
import { SignOnClick, SelectCertificateOnClick } from "@/utils/CryptoKit"
import {
  initTransToAccountOrBankApi,
  submitTransToAccountApi,
  initTransToAutoApi,
  submitTransToCardApi,
  submitTransToAutoApi,
  submitUpdateTransToAutoApi,
  queryPayRecord,
  accountTypeList,
  queryBankByNameResp
} from '@/api/dopay/transfer'
import jQuery from 'jquery'
import { printFn } from '@/utils/mathjs'
import { addOperateLog } from '@/api/security/operateRecord'
import Common from '@/utils/common' // 工具类
import CommonApi from '@/api/common/common'
import pgeditorFn from '@/utils/pgeditor'
const pgeditorPayment = pgeditorFn('_ocx_password', 1, '[0-9]*', '[0-9]{6,6}')
const pgeditorTrade = pgeditorFn('_ocx_password1', 2, '[0-9]*', '[0-9]{6,6}')
const pgeditorAuto = pgeditorFn('_ocx_password2', 3, '[0-9]*', '[0-9]{6,6}')
window.pgeCtrl = pgeditorPayment

export default {
  data() {
    const reg = /(^[\d]|^[1-9][\d]*)($|[\.][\d]{0,2}$)/
    var validateAmount = (rule, value, callback) => {
      if (!reg.test(value)) {
        this.form.amount = parseFloat(this.form.amount.replace(/[^\d.]/g, '')).toFixed(2)
      }
      callback()
    }
    var validateMaxAmount = (rule, value, callback) => {
      if (isNaN(value) || value === '' || Number(value) === 0) {
        return callback(new Error('金额不能为空'))
      }
      if (this.balance != null && Number(value) > Number(this.balance)) {
        return callback(new Error('账户余额不足'))
      }
      callback()
    }
    var validateBankAmount = (rule, value, callback) => {
      if (!reg.test(value)) {
        this.transToBankForm.recBankTransferAmt = parseFloat(this.transToBankForm.recBankTransferAmt.replace(/[^\d.]/g, '')).toFixed(2)
      }
      callback()
    }
    var validateBankMaxAmount = (rule, value, callback) => {
      if (isNaN(value) || value === '' || Number(value) === 0) {
        return callback(new Error('金额不能为空'))
      }
      if (this.balance != null && Number(value) > Number(this.balance)) {
        return callback(new Error('账户余额不足'))
      }
      if (this.maxAmount.length > 0 && Number(value) > Number(this.maxAmount)) {
        return callback(new Error('当前转账金额超过最大转账金额'))
      }
      callback()
    }
    return {
      initTransferForm: {
        // customerId: Session.getItem('customerId'),
        // code: Session.getItem('customerCode'),
        // customerType: Session.getItem('customerType'),
        // customerName: store.getters.name
        customerId: null,
        code: null,
        customerType: null,
        customerName: null
      },
      transferToAccountForm: {
        accountName: '',
        transferAmount: '',
        transferFee: '',
        tradePassWord: '',
        remark: '',
        // customerId: Session.getItem('customerId'),
        // code: Session.getItem('customerCode'),
        // customerType: Session.getItem('customerType'),
        // customerName: store.getters.name,
        customerId: null,
        code: null,
        customerType: null,
        customerName: null,
        tarCustomerId: ''
      },
      transToBankForm: {
        accountType: '01',
        bankNumber: '',
        bankCode: '',
        provinceName: '',
        bankName: '',
        recUserName: '',
        recCardNo: '',
        recBankTransferAmt: '',
        nuccCode: '',
        transferFee: '0',
        // customerId: Session.getItem('customerId'),
        // customerType: Session.getItem('customerType'),
        // customerName: store.getters.name,
        // code: Session.getItem('customerCode'),
        customerId: null,
        customerType: null,
        customerName: null,
        code: null,
        paymentPassword: '',
        remark: ''
      },
      activeName: 'transferToAccount',
      rateType: '',
      rate: '',
      minFee: '',
      maxFee: '',
      balance: '0.00',
      bankRateType: '',
      bankRate: '',
      bankMinFee: '',
      bankMaxFee: '',
      // 自动转账表单
      transToAutoForm: {
        // 自动转账时间
        paymentTime: ['10:00:00'],
        // 客户id
        customerId: null,
        // 客户编号
        customerNo: null,
        // 客户名称
        customerName: null,
        // 启用状态 01-关闭；02-开启
        status: null,
        // 存留金额
        keepBalance: null,
        // 收款卡号
        cardNo: null,
        // 卡类型
        accountType: null,
        // 银行编码
        bankCode: null,
        // 客户类型
        customerType: null,
        // 交易类型
        tradeType: null,
        // 转账说明
        remark: null,
        // 账户名称
        payeeName: null,
        // 账户
        account: null,
        paymentPassword: null,
        // nuccCode
        nuccCode: null,
        shortCode: null
      },
      // 自动转账费率描述
      autoFeeMsg: null,
      // 自动转账配置id
      autoPayId: null,
      // 账户银行信息列表
      autoBankList: [],
      // 账户列表枚举
      accountList: [],
      // 自动转账loading
      loadingAutoTransfer: false,
      // 修改标识
      updateFlag: false,
      // 取消按钮名称
      autoCancelButText: '取消',
      // 取消按钮loading
      autoCancelButloading: false,
      // 开启按钮名称
      autoOpenButText: '开启自动转账',
      // 开启按钮loading
      autoOpenButloading: false,
      // 历史记录
      payRecordList: [],
      // 账户类型
      accountTypeList: accountTypeList,
      bankItem: {
        historyFlag: false,
        disBankFlag: false,
        cardTypeFlag: false,
        bankName: '',
        codeAndName: ''
      },
      // 校验规则
      rules: {
        accountName: [
          {
            required: true,
            trigger: 'blur',
            message: '请输入转账账户'
          }
        ],
        // 校验金额
        transferAmount: [
          {
            required: true,
            trigger: 'blur',
            validator: validateMaxAmount
          },
          {
            trigger: 'change',
            validator: validateAmount
          }
        ]
      },
      bankRules: {
        accountType: [
          {
            required: true,
            trigger: 'change',
            message: '请选择收款账户类型'
          }
        ],
        bankCode: [
          {
            required: true,
            trigger: 'blur',
            message: '请选择银行'
          }
        ],
        recCardNo: [
          {
            required: true,
            trigger: 'blur',
            message: '请输入储蓄卡号'
          }
        ],
        recUserName: [
          {
            required: true,
            trigger: 'blur',
            message: '请输入开户人姓名'
          }
        ],
        // 校验金额
        recBankTransferAmt: [
          {
            required: true,
            trigger: 'blur',
            validator: validateBankMaxAmount
          },
          {
            trigger: 'change',
            validator: validateBankAmount
          }
        ]
      },
      autoRules: {
        account: [
          {
            required: true,
            trigger: 'blur',
            message: '请选择收款账户！'
          }
        ],
        // 存留金额校验
        keepBalance: [
          {
            required: true,
            message: '存留金额不能为空！'
          }, {
            // 日累计金额校验
            validator: (rule, value, callback) => {
              let errorMessage = ''
              const pattern = new RegExp(/(^[\-0-9][0-9]*(.[0-9]+)?)$/)
              if (value !== null && value !== '' && !pattern.test(value)) {
                errorMessage = '存留金额只能是数字'
              }
              errorMessage !== '' ? callback(new Error(errorMessage)) : callback()
            }
          }
        ]
      },
      dialogFormVisible: false,
      loadingSubmitBut: false,
      loadingSubmitButtext: '提交',
      loadingOpenDialogBut: false,
      loadingOpenDialogButtext: '提交',
      loadingBankSubmitBut: false,
      loadingBankSubmitButtext: '提交',
      customerList: [],
      bankList: [],
      maxAmount: '',
      bankFeeMsg: '',
      totAmount: '0',
      customerType: null,
      historyBank: {},
      contactName: null
    }
  },
  computed: {
    /* getMaxAmount() {
      return this.maxAmount.length > 0 ? '最高' + this.maxAmount : ''
    }*/
    merNo() {
      return this.$store.state.user.merNo
    }
  },
  created() {
    this.initTransferPage()
  },
  mounted() {
     jQuery('#paymentPassword').html(pgeditorPayment.load())
    jQuery('#lic').val(pgeditorPayment.setLicense())
    pgeditorPayment.pwdClear()
    jQuery('#tradePassword').html(pgeditorTrade.load())
    jQuery('#lic').val(pgeditorTrade.setLicense())
    pgeditorTrade.pwdClear()
    jQuery('#autoPassword').html(pgeditorAuto.load())
    jQuery('#lic').val(pgeditorAuto.setLicense())
    pgeditorAuto.pwdClear()
  },
  methods: {
    initTransferPage() {
      CommonApi.getMerNo({ merNo: this.merNo }).then(res => {
        this.initTransferForm.customerId = res.data.customer.id
        this.initTransferForm.customerName = res.data.customer.contactName
        this.initTransferForm.code = res.data.customer.code
        this.initTransferForm.customerType = res.data.customer.customerType

        this.transferToAccountForm.customerId = res.data.customer.id
        this.transferToAccountForm.customerName = res.data.customer.contactName
        this.transferToAccountForm.code = res.data.customer.code
        this.transferToAccountForm.customerType = res.data.customer.customerType

        this.transToBankForm.customerId = res.data.customer.id
        this.transToBankForm.customerName = res.data.customer.contactName
        this.transToBankForm.code = res.data.customer.code
        this.transToBankForm.customerType = res.data.customer.customerType

        // 自动转账赋值
        this.transToAutoForm.customerName = res.data.customer.name
        this.transToAutoForm.customerNo = res.data.customer.code
        this.transToAutoForm.customerId = res.data.customer.id
        this.transToAutoForm.customerType = res.data.customer.customerType
        

        this.initTransToAccountApi()

        const param2 = Object.assign({}, { counterPartyAccountType: '02' }, this.initTransferForm)
        initTransToAccountOrBankApi(param2).then(res => {
          // console.log(res)
          this.bankRateType = res.data.rateType
          this.bankRate = res.data.rate
          this.bankMinFee = res.data.minFee
          this.bankMaxFee = res.data.maxFee
          // 计算手续费
          if (this.bankRateType === '02') {
            // 固定金额费率
            this.bankFeeMsg = '收取' + this.bankRate + '元服务费。'
          } else if (this.bankRateType === '01') {
            // 百分比费率
            this.bankFeeMsg = '收取' + this.toPercent(this.bankRate / 100) + '服务费，最低' + this.bankMinFee + '元。'
          }
        }).catch(error => {
          console.log(error) // 请求失败返回的数据
        })
        const listParam = {
          orgType: '01',
          pageNum: 1,
          pageSize: 9999
        }
        CommonApi.getBankList(listParam).then(res => {
          this.bankList = res.data.list
          for (const item of this.bankList) {
            item.codeAndName = item.nuccCode + item.bankName
          }
        }).catch(error => {
          console.log(error) // 请求失败返回的数据
        })
        this.initTransferToAuto()
        this.queryPayRecord(this.transToAutoForm.customerNo)
      })
    },
    initTransToAccountApi() {
      const param1 = Object.assign({}, { counterPartyAccountType: '01' }, this.initTransferForm)
      initTransToAccountOrBankApi(param1).then(res => {
        // console.log(res)
        this.rateType = res.data.rateType
        this.rate = res.data.rate
        this.minFee = res.data.minFee
        this.maxFee = res.data.maxFee
        this.balance = res.data.amount
      }).catch(error => {
        console.log(error) // 请求失败返回的数据
      })
    },
    initTransferToAuto() {
      // 清空密码
      jQuery('#autoPassword').html(pgeditorAuto.load())
      jQuery('#lic').val(pgeditorAuto.setLicense())
      pgeditorAuto.pwdClear()
      this.transToAutoForm.paymentPassword = null
      // 修改状态
      this.updateFlag = false
      // 自动转账初始化
      const queryParam = {
        cusCode: this.transToAutoForm.customerNo,
        customerId: this.transToAutoForm.customerId,
        customerType: this.transToAutoForm.customerType
      }
      initTransToAutoApi(queryParam).then(res => {
        this.loadingAutoTransfer = false
        this.autoCancelButText = '取消'
        this.autoCancelButloading = false
        this.autoOpenButText = '开启自动转账'
        this.autoOpenButloading = false
        // 添加自动初始化获取转账时间
        let { paymentTime } = res.data
        if (paymentTime) {
          paymentTime = paymentTime.split(',')
          this.transToAutoForm.paymentTime = paymentTime.length > 0 ? paymentTime : ['10:00:00']
        } else {
          this.transToAutoForm.paymentTime = ['10:00:00']
        }
        const bankCardsList = res.data.bankCardsList
        this.autoBankList = bankCardsList
        this.accountList = []
        if (bankCardsList.length > 0) {
          for (var i = 0; i < bankCardsList.length; i++) {
            const banklist = {
              value: i,
              label: bankCardsList[i].accountNameMask + ' ' + bankCardsList[i].accountBank + ' ' + bankCardsList[i].bankCardNoMask
            }
            this.accountList.push(banklist)
          }
        }
        console.log('accountList',this.accountList)
        // 计算手续费 利率类型 01-百分比；02-数字
        if (res.data.feeType === '02') {
          // 固定金额费率
          this.autoFeeMsg = res.data.fee + '元/笔'
        } else if (res.data.feeType === '01') {
          // 百分比费率
          this.autoFeeMsg = '按金额的' + this.toPercent(res.data.fee) + '收取服务费，最低' + res.data.capitalMin + '元起,上限' + res.data.capitalTop + '元封顶。'
        }
        // 未开通自动转账
        if (res.data.autoPayId === null) {
          // 自动转账配置id
          this.autoPayId = null
          // 存留金额
          this.transToAutoForm.keepBalance = null
          // 收款卡号
          this.transToAutoForm.cardNo = null
          // 卡类型
          this.transToAutoForm.accountType = null
          // 银行编码
          this.transToAutoForm.bankCode = null
          // 账户名称
          this.transToAutoForm.payeeName = null
          // nuccCode
          this.transToAutoForm.nuccCode = null
          // shortCode
          this.transToAutoForm.shortCode = null
          // 交易类型
          this.transToAutoForm.tradeType = res.data.tradetype
          this.transToAutoForm.bankBranch = null
          this.transToAutoForm.bankNumber = null
          // 账户
          this.transToAutoForm.account = null
          // 转账说明
          this.transToAutoForm.remark = null
        } else {
          // 自动转账配置id
          this.autoPayId = res.data.autoPayId
          // 存留金额
          this.transToAutoForm.keepBalance = res.data.keepBalance
          // 收款卡号
          this.transToAutoForm.cardNo = res.data.bankCardsList[0].bankCardNo
          // 卡类型
          this.transToAutoForm.accountType = res.data.bankCardsList[0].accountType
          // 银行编码
          this.transToAutoForm.bankCode = res.data.bankCardsList[0].accountBankNo
          // 账户名称
          this.transToAutoForm.payeeName = res.data.bankCardsList[0].accountName
          // nuccCode
          this.transToAutoForm.nuccCode = res.data.bankCardsList[0].nuccCode
          // shortCode
          this.transToAutoForm.shortCode = res.data.bankCardsList[0].shortCode
          // 交易类型
          this.transToAutoForm.tradeType = res.data.tradetype
          this.transToAutoForm.bankBranch = res.data.bankBranch
          this.transToAutoForm.bankNumber = res.data.bankNumber
          // 账户
          this.transToAutoForm.account = 0
          // 转账说明
          this.transToAutoForm.remark = res.data.remark
        }
      }).catch(error => {
        this.loadingAutoTransfer = false
        this.autoCancelButText = '取消'
        this.autoCancelButloading = false
        this.autoOpenButText = '开启自动转账'
        this.autoOpenButloading = false
        console.log(error) // 请求失败返回的数据
      })
    },
    // 表单提交
    formSubmit(formName) {
      // 计算费率
      if (this.rateType === '02') {
        // 固定金额费率
        this.transferToAccountForm.transferFee = this.rate
      } else if (this.rateType	 === '01') {
        // 百分比费率
        this.transferToAccountForm.transferFee = printFn(this.transferToAccountForm.transferAmount * this.rate / 100).toFixed(2)
        if (this.transferToAccountForm.transferFee > this.maxFee) {
          this.transferToAccountForm.transferFee = this.maxFee
        }
        if (this.transferToAccountForm.transferFee < this.minFee) {
          this.transferToAccountForm.transferFee = this.minFee
        }
      }
      // console.log(this.$refs[formName])
      this.$refs[formName].validate((valid) => {
        if (valid) {
          pgeditorTrade.pwdSetSk('d8mujn26fstqdozzq3iijpsvx71g74du')
          const password = pgeditorTrade.pwdResultSM()
          if (password === '') {
            this.$message({
              message: '请输入支付密码',
              type: 'error'
            })
            return false
          }
          this.transferToAccountForm.tradePassWord = password
          // console.log('-------------success')
          this.loadingSubmitBut = true
          this.loadingSubmitButtext = '提交中...'
          const param = Object.assign({}, this.transferToAccountForm)
          const logParam = Common.setNull({
            // merNo: Session.getItem('merNo') === 'null' ? null : Session.getItem('merNo'),
            merNo: this.merNo ? this.merNo : null,
            operateIp: sessionStorage.getItem('ip'),
            operateName: '转账'
          })
          submitTransToAccountApi(param).then(res => {
            // console.log(res)
            if (res.data.transferStatus === 'true') {
              const otherLogParam = {
                operateResult: res.code,
                remark: res.message
              }
              addOperateLog(Object.assign({}, logParam, otherLogParam))
              this.$message({
                message: '转账成功',
                type: 'success'
              })
              const busline = localStorage.getItem('busline') ? localStorage.getItem('busline') : 'NET_PAY'
              this.$router.push({ path: '/' + busline.split('_').join('').toLowerCase() + '/index' })
            } else {
              this.$message.error('转账失败')
            }
            this.loadingSubmitBut = false
            this.loadingSubmitButtext = '提交'
            this.dialogFormVisible = false
          }).catch(error => {
            console.log(error) // 请求失败返回的数据
            const otherLogParam = {
              operateResult: '9999',
              remark: error.toString()
            }
            addOperateLog(Object.assign({}, logParam, otherLogParam))
            this.loadingSubmitBut = false
            this.loadingSubmitButtext = '提交'
            this.dialogFormVisible = false
          })
        } else {
          console.log('-------------error')
          this.dialogFormVisible = false
          return false
        }
      })
    },
    openDialog(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // console.log('-------------success')
          this.loadingOpenDialogBut = true
          this.loadingOpenDialogButtext = '提交中...'
          const param = Object.assign({}, { accountNo: this.transferToAccountForm.accountName })
          this.dialogFormVisible = true
          CommonApi.customerInfoSearch(param).then(res => {
            //console.log(res)
            if (res.data.length === 0) {
              this.$message.error('账户不存在')
            } else {
              // if (this.transferToAccountForm.customerType === this.customerType) {
              this.dialogFormVisible = true
              // } else {
              //   this.$message.error('企业账户和个人账户不能互转')
              // }
            }
            this.loadingOpenDialogBut = false
            this.loadingOpenDialogButtext = '提交'
          }).catch(error => {
            console.log(error) // 请求失败返回的数据
            this.loadingOpenDialogBut = false
            this.loadingOpenDialogButtext = '提交'
          })
        } else {
          console.log('-------------error')
          return false
        }
      })
    },
    handleClose() {
      this.dialogFormVisible = false
    },
    querySearch(queryString, cb) {
      var restaurants = []
      if (queryString !== '' && queryString.length > 5) {
        const param = Object.assign({}, { accountNo: queryString })
        CommonApi.customerInfoSearch(param).then(res => {
          // console.log(res)
          restaurants = res.data
          for (var i = 0; i < restaurants.length; i++) {
            // if (this.initTransferForm.customerType === restaurants[i].customerType) {
            if (restaurants[i].customerType === '6') {
              restaurants[i].value = restaurants[i].contactName + '(个人客户)'
            } else if (restaurants[i].customerType === '8') {
              if (restaurants[i].companyName) {
                restaurants[i].value = restaurants[i].companyName + '(企业客户)'
              } else {
                restaurants[i].value = restaurants[i].corporationName + '(企业客户)'
              }
            }
            // }
          }
          // 调用 callback 返回建议列表的数据
          cb(restaurants)
        }).catch(error => {
          console.log(error) // 请求失败返回的数据
          // 调用 callback 返回建议列表的数据
          cb(restaurants)
        })
      } else {
        // 调用 callback 返回建议列表的数据
        cb(restaurants)
      }
    },
    handleSelect(item) {
      // console.log(item, 'item')
      this.contactName = item.value
      this.transferToAccountForm.accountName = item.phone
      this.transferToAccountForm.tarCustomerId = item.id
      this.customerType = item.customerType
    },
    getBankBean(selVal) {
      const bankitem = this.bankList.find((item) => {
        return item.codeAndName === selVal
      })
      this.transToBankForm.bankCode = bankitem.shortCode ? bankitem.shortCode : bankitem.bankCode
      this.transToBankForm.nuccCode = bankitem.nuccCode
      this.bankItem.bankName = bankitem.bankName
      // item.id+'-'+item.shortCode+'-'+item.nuccCode
      // this.transToBankForm.bankCode = selVal.split('-')[1]
      // this.transToBankForm.nuccCode = selVal.split('-')[2]
    },
    getBankFee() {
      if (isNaN(this.transToBankForm.recBankTransferAmt) ||
          this.transToBankForm.recBankTransferAmt === '' ||
          Number(this.transToBankForm.recBankTransferAmt) === 0) {
        this.transToBankForm.transferFee = '0'
        this.totAmount = '0'
      } else {
        // 计算费率
        if (this.bankRateType === '02') {
          // 固定金额费率
          this.transToBankForm.transferFee = this.bankRate
        } else if (this.bankRateType	 === '01') {
          // 百分比费率
          this.transToBankForm.transferFee = printFn(this.transToBankForm.recBankTransferAmt * this.bankRate / 100).toFixed(2)
          if (this.transToBankForm.transferFee > this.bankMaxFee) {
            this.transToBankForm.transferFee = this.bankMaxFee
          }
          if (this.transToBankForm.transferFee < this.bankMinFee) {
            this.transToBankForm.transferFee = this.bankMinFee
          }
        }
        this.totAmount = Number(Number(this.transToBankForm.recBankTransferAmt) + Number(this.transToBankForm.transferFee)).toFixed(2)
      }
    },
    bankFormSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
           pgeditorPayment.pwdSetSk('d8mujn26fstqdozzq3iijpsvx71g74du')
          const password = pgeditorPayment.pwdResultSM()
          if (password === '') {
            this.$message({
              message: '请输入支付密码',
              type: 'error'
            })
            return false
          }
          this.transToBankForm.paymentPassword = password
          // console.log('-------------success')
          this.loadingBankSubmitBut = true
          this.loadingBankSubmitButtext = '提交中...'
          this.transToBankForm.bankName = this.bankItem.bankName
          const param = Object.assign({}, this.transToBankForm)
          let reg = /\*/
          if (reg.test(param.recCardNo)) {
            param.recCardNo = this.historyBank.accNoEnc
            param.recUserName = this.historyBank.accNameEnc
            param.signType = '01'
          }else {
            param.signType = '00'
          }
          param.isCfcaDecrypt = SelectCertificateOnClick() ? true : false
          let { recCardNo, recUserName } = param
          param.recCardNo = SignOnClick(recCardNo).result
          param.recUserName = SignOnClick(recUserName).result
          submitTransToCardApi(param).then(res => {
            this.historyBank = {}
            // console.log(res)
            this.loadingBankSubmitBut = false
            this.loadingBankSubmitButtext = '提交'
            // 转账成功后刷新余额
            this.initTransToAccountApi()
            // 转账成功后刷新转账记录
            this.queryPayRecord(this.transToAutoForm.customerNo)
            this.$message({
              message: '转账成功',
              type: 'success'
            })
            const busline = localStorage.getItem('busline') ? localStorage.getItem('busline') : 'NET_PAY'
            this.$router.push({ path: '/' + busline.split('_').join('').toLowerCase() + '/index' })
            // this.$router.push({
            //   name: 'index'
            // })
          }).catch(error => {
            // console.log(error) // 请求失败返回的数据
            this.loadingBankSubmitBut = false
            this.loadingBankSubmitButtext = '提交'
            this.$message.error('转账失败')
          })
        } else {
          console.log('-------------error')
          return false
        }
      })
    },
    toPercent(point) {
      if (Number(point) === 0) {
        return 0
      }
      var str = Number(point * 100).toFixed(2)
      str += '%'
      return str
    },
    changeAccount() {
      console.log('666',this.autoBankList)
      const num = this.transToAutoForm.account
      // 收款卡号
      this.transToAutoForm.cardNo = this.autoBankList[num].bankCardNo
      // 卡类型
      this.transToAutoForm.accountType = this.autoBankList[num].accountType
      // 银行编码
      this.transToAutoForm.bankCode = this.autoBankList[num].accountBankNo
      // 账户名称
      this.transToAutoForm.payeeName = this.autoBankList[num].accountName
      this.transToAutoForm.nuccCode = this.autoBankList[num].nuccCode
      this.transToAutoForm.shortCode = this.autoBankList[num].shortCode
      this.transToAutoForm.tradeType = this.autoBankList[num].tradeType
      this.transToAutoForm.bankBranch = this.autoBankList[num].bankBranch
      this.transToAutoForm.bankNumber = this.autoBankList[num].bankNumber
    },
    autoFormSubmit() {
      this.$refs.transToAutoForm.validate((valid, model) => {
        if (valid) {
          this.transToAutoForm.status = '02'
          pgeditorAuto.pwdSetSk('d8mujn26fstqdozzq3iijpsvx71g74du')
          const password = pgeditorAuto.pwdResultSM()
          if (password === '') {
            this.$message({
              message: '请输入支付密码',
              type: 'error'
            })
            return false
          }
          this.transToAutoForm.paymentPassword = password
          const transToAutoForm = Common.setNull(this.transToAutoForm)
          const param = Object.assign({}, transToAutoForm)
          param.paymentTime = param.paymentTime ? param.paymentTime.join(',') : ''
          this.loadingAutoTransfer = true
          this.autoCancelButText = '开启中...'
          this.autoCancelButloading = true
          param.signType = '01'
          param.isCfcaDecrypt = SelectCertificateOnClick() ? true : false
          param.cardNo = SignOnClick(this.transToAutoForm.cardNo).result
          param.payeeName = SignOnClick(this.transToAutoForm.payeeName).result
          submitTransToAutoApi(param).then(res => {
            if (res.code !== '0000' && res.code !== '000000') {
              this.$message({
                message: '开启失败!' + res.message,
                type: 'error'
              })
            } else {
              this.$message({
                message: '开启成功!',
                type: 'success'
              })
              this.initTransferToAuto()
            }
            // console.log(res)
          }).catch(error => {
            this.autoOpenButText = '开启自动转账'
            this.autoOpenButloading = false
            console.log(error) // 请求失败返回的数据
          })
        }
      })
    },
    // 修改自动转账按钮
    autoUpdate() {
      this.updateFlag = true
    },
    // 取消修改自动转账按钮
    cancelUpdate() {
      this.updateFlag = false
      this.autoCancelButText = '取消中...'
      this.autoCancelButloading = true
      this.initTransferToAuto()
    },
    getPayRecord(res) {
      this.historyBank = res
      this.bankItem.codeAndName = res.nuccCode + res.accountBank
      this.transToBankForm.recUserName = res.accNameMask
      this.transToBankForm.recCardNo = res.accNoMask
      this.getBankBean(this.bankItem.codeAndName)
      // this.bankItem.disBankFlag = true
      // this.bankItem.historyFlag = true
      // this.bankItem.cardTypeFlag = true
      this.transToBankForm.accountType = '01'
      switch (res.accType) {
        case '00':
          break
        case '01':
          this.transToBankForm.accountType = '02'
          break
        default:
          // this.bankItem.cardTypeFlag = false
          break
      }
    },
    // 通过银行卡号获取银行类型或者名称
    getBankByNameResp() {
      if (!this.transToBankForm.recCardNo) {
        // this.bankItem.disBankFlag = false
        return
      }
      queryBankByNameResp({ cardNo: this.transToBankForm.recCardNo }).then(res => {
        let accountType = '01'
        // this.bankItem.cardTypeFlag = false
        if (res.data.nuccCode && res.data.bankName) {
          // this.bankItem.disBankFlag = true
          this.bankItem.codeAndName = res.data.nuccCode + res.data.bankName
          // this.bankItem.cardTypeFlag = true
          switch (res.data.cardType) {
            case '00':
              break
            case '01':
              accountType = '02'
              break
            default:
              // this.bankItem.cardTypeFlag = false
              break
          }
        } else {
          this.bankItem.codeAndName = ''
          // this.bankItem.disBankFlag = false
        }
        this.transToBankForm.accountType = accountType
        this.getBankBean(this.bankItem.codeAndName)
      }).catch(error => {
        // this.bankItem.disBankFlag = false
        // this.bankItem.cardTypeFlag = false
        this.bankItem.codeAndName = ''
        console.log(error) // 请求失败返回的数据
      })
    },
    // 转账历史记录查询
    queryPayRecord(data) {
      queryPayRecord({ customerNo: data }).then(res => {
        
        this.payRecordList = res.data.list
      }).catch(error => {
        console.log(error) // 请求失败返回的数据
      })
    },
    autoFormUpdateSubmit(type) {
      let str = null
      if (type === '01') {
        str = '关闭自动转账'
      } else if (type === '02') {
        str = '修改'
      }
      this.$confirm(
        '确定要进行“' + str + '”操作吗？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          this.$refs.transToAutoForm.validate((valid, model) => {
            if (valid) {
              if (type === '01') {
                this.transToAutoForm.status = '01'
              } else if (type === '02') {
                this.transToAutoForm.status = '02'
              }

              pgeditorAuto.pwdSetSk('d8mujn26fstqdozzq3iijpsvx71g74du')
              const password = pgeditorAuto.pwdResultSM()
              if (password === '') {
                this.$message({
                  message: '请输入支付密码',
                  type: 'error'
                })
                return false
              }
              this.transToAutoForm.paymentPassword = password
              const otherParam = {
                autoPayid: this.autoPayId
              }
              const transToAutoForm = Common.setNull(this.transToAutoForm)
              const param = Object.assign({}, otherParam, transToAutoForm)
              param.paymentTime = param.paymentTime ? param.paymentTime.join(',') : ''
              this.loadingAutoTransfer = false
              param.signType = '01'
              param.isCfcaDecrypt = SelectCertificateOnClick() ? true : false
              param.cardNo = SignOnClick(this.transToAutoForm.cardNo).result
              param.payeeName = SignOnClick(this.transToAutoForm.payeeName).result
              submitUpdateTransToAutoApi(param).then(res => {
                if (res.code !== '0000' && res.code !== '000000') {
                  this.$message({
                    message: str + '失败!' + res.message,
                    type: 'error'
                  })
                } else {
                  this.$message({
                    message: str + '成功!',
                    type: 'success'
                  })
                  this.initTransferToAuto()
                }
                // console.log(res)
              })
            }
          })
        })
    }
  }
}
</script>
<style scoped>
    .headet-title {
        padding: 10px 30px 20px 30px;
    }

    .headet-title .headet-title-box {
        font-size: 16px;
        padding: 10px 0;
        border-bottom: 1px solid #DBDDE2;
    }

    .pb-50 {
        padding-bottom: 50px;
    }
    .transfer-body /deep/.el-form-item /deep/.ocx_style {
      border: 1px solid #dcdfe6;
      line-height: 40px;
      height: 40px;
      width: 200px;
      border-radius: 4px;
      padding: 0 15px;
    }
</style>
<style>
  #tradePassword,
  #paymentPassword,
  #autoPassword {
    height: 40px;
  }
  #tradePassword input,
  #paymentPassword input,
  #autoPassword input,
  #tradePassword #_ocx_password,
  #paymentPassword #_ocx_password1,
  #autoPassword #_ocx_password2 {
    border: 1px solid #dcdfe6;
    line-height: 40px;
    height: 40px;
    width: 90%;
    border-radius: 4px;
    padding: 0 15px;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
    margin: 0;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }
</style>
